import { type FC } from 'react';

import { BxMobileBx687NewMainpageExperiment } from 'shared/experiments';

import { MainpageBrandMobile, type TMainpageBrandMobileProps } from '../MainpageBrandMobile';
import { MainpageBrandMobileRedesign } from '../MainpageBrandMobileRedesign';

export const MainpageBrandMobileExperiment: FC<TMainpageBrandMobileProps> = ({ completeContext }) => {
  const group = BxMobileBx687NewMainpageExperiment.use();

  if (group === 'B') {
    return <MainpageBrandMobileRedesign completeContext={completeContext} />;
  }

  return <MainpageBrandMobile completeContext={completeContext} />;
};
